import { Tenant } from './tenants';

const upsertLink = (rel: string, href: string) => {
  let link = document.head.querySelector<HTMLLinkElement>(`link[rel="${rel}"]`);
  if (!link) {
    link = document.createElement('link');
    link.rel = rel;
    document.head.appendChild(link);
  }
  link.setAttribute('href', href);
};

const upsertMeta = (name: string, content: string) => {
  let meta = document.head.querySelector<HTMLMetaElement>(`meta[name="${name}"]`);
  if (!meta) {
    meta = document.createElement('meta');
    meta.name = name;
    document.head.appendChild(meta);
  }
  meta.content = content;
};

/** Google Tag Manager's standard snippet, run only for a brand that has a container. */
const loadTagManager = (id: string) => {
  if (document.querySelector(`script[data-gtm="${id}"]`)) return;
  const w = window as unknown as { dataLayer?: unknown[] };
  w.dataLayer = w.dataLayer || [];
  w.dataLayer.push({ 'gtm.start': new Date().getTime(), event: 'gtm.js' });
  const script = document.createElement('script');
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtm.js?id=${id}`;
  script.dataset.gtm = id;
  const first = document.getElementsByTagName('script')[0];
  if (first?.parentNode) first.parentNode.insertBefore(script, first);
  else document.head.appendChild(script);
};

/**
 * Brands the page before React renders: title, icons, theme colour, the brand's CSS colours and
 * analytics. index.html carries none of these, so no brand shows another's while the bundle loads.
 */
export function applyTenantChrome(tenant: Tenant): void {
  const { brand, theme } = tenant;
  const root = document.documentElement;

  document.title = brand.name;
  root.dataset.tenant = tenant.key;
  root.style.setProperty('--red', theme.red);
  root.style.setProperty('--light-red', theme.lightRed);
  root.style.setProperty('--red-rgb', theme.redRgb);
  root.style.setProperty('--on-red', theme.onRed);
  root.style.setProperty('--red-deep', theme.redDeep);
  root.style.setProperty('--danger', theme.danger);
  root.style.setProperty('--danger-rgb', theme.dangerRgb);
  root.style.setProperty('--danger-text', theme.dangerText);
  root.style.setProperty('--accent', theme.accent);
  root.style.setProperty('--accent-rgb', theme.accentRgb);

  upsertLink('icon', brand.favicon);
  upsertLink('apple-touch-icon', brand.appleTouchIcon);
  upsertMeta('description', brand.description);
  upsertMeta('theme-color', brand.themeColor);

  if (brand.gtmId) loadTagManager(brand.gtmId);
}
